
































































import { BulkUploadDTO, BulkResponseDTO, ApiResponseStatus } from '@/api/bulk/types';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import AgroGenericModal from "@/components/agroGenericModal/AgroGenericModal.vue";
import Icon from "@/components/agroIcons/AgroIcons.vue";
import { ValidationResponse, validateBulkRecord} from "@/services/bulk/index";
import { plainToClassFromExist as ptc } from 'class-transformer';
import { roundedWithFracDigits } from '@/filters/scalar';
import * as service from '@/services/bulk';

@Component({
  name: 'BulkUploaderValidator',
  components: {
    AgroGenericModal,
    Icon,
  },
  filters: {
    roundedWithFracDigits,
  }
})
export default class BulkUploaderValidator extends Vue {

  @Prop({type: Array, default: () => []})
  private records!: BulkUploadDTO[];

  @Prop({type: Boolean, default: true})
  private isVisible!: boolean;

  private saving: boolean = false;
  private changedLabel: boolean = false;

  private get fields() {
    const allFields: Array<keyof BulkUploadDTO>  = ['farmName', 'ownerId', 'ownerName', 'lat', 'lng', 'carCode', 'incraAllotment', 'analitica', 'sentinela', 'cropType1', 'cropType2']
    const existingFields = this.records.reduce((existing, record) => {
        for (const field of allFields) {
          if (!!record[field]) {
            existing.add(field);
          }
        }
        return existing
    }, new Set<keyof BulkUploadDTO>());

    return allFields.filter(f => existingFields.has(f));
  }

  private get recordsValidityAsEnum() {
    return this.records.map(validateBulkRecord);
  }

  private get recordsValidity() {
    return this.recordsValidityAsEnum.map(v => ValidationResponse[v]);
  }

  private get recordsToUpload() {
    return this.records.filter((it, i) => this.recordsValidityAsEnum[i] === ValidationResponse.VALID);
  }

  private get validationStats() {
    return {
      valid: this.recordsValidityAsEnum.filter(v => v === ValidationResponse.VALID).length,
      invalid: this.recordsValidityAsEnum.filter(v => v !== ValidationResponse.VALID).length,
    }
  }

  @Emit('oncancel')
  private cancelAction() {
  }

  @Emit('onconfirm')
  private async confirmAction() {
    await this.save();
  }

  private getApiResponseStatus(responseDTO: BulkResponseDTO) {
    const prefix = 'farms-home.bulk-uploader-validator';
    let message = new Set();

    if (responseDTO.ownerStatus) {
      message.add(this.$t(`${prefix}.owner-api-response-status.${responseDTO.ownerStatus}`) as string);
    }
    if (responseDTO.farmStatus) {
      message.add(this.$t(`${prefix}.farm-api-response-status.${responseDTO.farmStatus}`) as string);
    }
    responseDTO.analyses?.forEach(it => message.add(this.$t(`${prefix}.analysis-api-response-status.${it.status}`, {crop_type: it.cropType, type: it.type}) as string))

    return [...message].join(' ');
  } 

  private responseClass(responseDTO: BulkResponseDTO) {
    let message = new Set();

    if (responseDTO.ownerStatus) {
      message.add(responseDTO.ownerStatus);
    }
    if (responseDTO.farmStatus) {
      message.add(responseDTO.farmStatus);
    }
    responseDTO.analyses?.forEach(it => message.add(it.status));

    return [...message].join(' ').toLowerCase();
  } 

  private async save() {
    this.saving = true;
    this.changedLabel = true;

    for (const it of this.recordsToUpload) {
      delete it.apiResponse;
    }
    this.$forceUpdate();

    for (const it of this.recordsToUpload) {
      const apiResponse = await service.create(it);
      it.apiResponse = apiResponse;
      this.$forceUpdate();
    }

    this.saving = false;
  }

}
